// Mirrors app/services/twilio_segment_calculator.rb so live segment counters match
// the server-side estimate.
const GSM_7BIT_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
const GSM_7BIT_EXTENDED = "^{}\\[~]|€"

export function segmentsFor(message: string): number {
  if (!message) return 0

  const chars = Array.from(message)
  const gsmCompatible = chars.every(
    (char) => GSM_7BIT_BASIC.includes(char) || GSM_7BIT_EXTENDED.includes(char)
  )

  if (gsmCompatible) {
    const length = chars.reduce(
      (sum, char) => sum + (GSM_7BIT_EXTENDED.includes(char) ? 2 : 1),
      0
    )
    return length <= 160 ? 1 : Math.ceil(length / 153)
  }

  const length = chars.length
  return length <= 70 ? 1 : Math.ceil(length / 67)
}
